import React from "react";
import { Button } from "antd";
import styles from "./UiPrimitives.module.css";

const sizeClassMap = {
  sm: styles.uiButtonSm,
  md: styles.uiButtonMd,
  lg: styles.uiButtonLg,
};

const variantClassMap = {
  primary: "",
  secondary: styles.uiButtonSecondary,
  /* A secondary button that happens to do something irreversible - outlined
     rather than filled, so it reads as the alarm it is without competing with
     the primary action beside it. */
  danger: styles.uiButtonDanger,
  ghost: styles.uiButtonGhost,
  text: styles.uiButtonText,
};

const toAntType = (variant) => {
  if (variant === "text") return "text";
  if (variant === "secondary" || variant === "danger") return "default";
  return "primary";
};

const UiButton = ({
  variant = "primary",
  size = "md",
  className,
  children,
  ...props
}) => {
  const classNames = [
    styles.uiButton,
    sizeClassMap[size] || sizeClassMap.md,
    variantClassMap[variant] || "",
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Button
      type={toAntType(variant)}
      ghost={variant === "ghost"}
      className={classNames}
      {...props}
    >
      {children}
    </Button>
  );
};

export default UiButton;
